import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Owner = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" {...props}>
    <path
      clipRule="evenodd"
      d="M4.09068 3.90058C3.3933 3.2666 2.28632 3.86105 2.42963 4.79257L4 15H20L21.5704 4.79257C21.7137 3.86105 20.6067 3.26659 19.9093 3.90057L16.5 6.99996L12.8 2.06663C12.4 1.53329 11.6 1.53329 11.2 2.06663L7.5 6.99996L4.09068 3.90058ZM18.2842 13L19.164 7.28107L16.2189 9.95845L12 4.33329L7.78113 9.95845L4.83601 7.28107L5.71584 13H18.2842Z"
      fill="currentColor"
      fillRule="evenodd"
    />
    <path d="M6 18H4V16H6V18Z" fill="currentColor" />
    <path d="M18 18H20V16H18V18Z" fill="currentColor" />
    <path d="M9.5 18H7.5V16H9.5V18Z" fill="currentColor" />
    <path d="M11 16V18H13V16H11Z" fill="currentColor" />
    <path d="M16.5 18H14.5V16H16.5V18Z" fill="currentColor" />
    <path d="M4 19V21H20V19H4Z" fill="currentColor" />
  </Icon>
));

export default Owner;
